module.exports = require("/codebuild/output/src197938941/src/github.com/grounded-it-solutions/external-website/src/state/createStore")